import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { ISupportedLanguage } from './models/language.model';

@Injectable({
	providedIn: 'root',
})
export class LanguageRequester extends DcBaseRequester<ISupportedLanguage> {
	protected resource: string;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('LANGUAGE');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = `${this.elementsListUrl}/{templateId}`;
	}

	public getSupportedLanguages(): Observable<
		ReadonlyArray<ISupportedLanguage>
	> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		return this.get<ReadonlyArray<ISupportedLanguage>>(
			url,
			CachePolicyEntity.build({
				policy: CachePolicy.CacheOnly,
				evictTimeoutInSeconds: 3600,
				isCacheable: true,
			})
		);
	}
}
